import { useAppNotificationCounts } from 'src/hooks/useSidebarNotificationCounts/useAppNotificationCounts';
import { useContractsNotificationCount } from 'src/hooks/useSidebarNotificationCounts/useContractsNotificationCount';
import { useFilesNotificationCount } from 'src/hooks/useSidebarNotificationCounts/useFilesNotificationCount';
import { useFormsNotificationCount } from 'src/hooks/useSidebarNotificationCounts/useFormsNotificationCount';
import { useInvoicesNotificationCount } from 'src/hooks/useSidebarNotificationCounts/useInvoicesNotificationCount';
import { useMessagesNotificationCount } from 'src/hooks/useSidebarNotificationCounts/useMessagesNotificationCount';

export interface SidebarNotificationCounts {
  messages: number;
  files: number;
  invoices: number;
  forms: number;
  contracts: number;
  apps: Record<string, number>;
}

export const useSidebarNotificationCounts = (): SidebarNotificationCounts => {
  const messages = useMessagesNotificationCount();
  const files = useFilesNotificationCount();
  const invoices = useInvoicesNotificationCount();
  const forms = useFormsNotificationCount();
  const contracts = useContractsNotificationCount();
  const apps = useAppNotificationCounts();

  return {
    messages,
    files,
    invoices,
    forms,
    contracts,
    apps,
  };
};
